module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-light-300.a624ea3f.eot";